var _defs, _rect, _polygon, _polygon2, _path, _rect2, _rect3, _rect4, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7.106 9.529 140.59 130.777",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f43567e1-086e-4b37-b6cb-48994d2df091",
    x1: 37.26,
    y1: 31.69,
    x2: 46.03,
    y2: 31.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ba8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a05eb05f-654a-4e10-b5ca-8c551876a400",
    x1: 31.64,
    y1: 18.87,
    x2: 131.54,
    y2: 18.87,
    xlinkHref: "#f43567e1-086e-4b37-b6cb-48994d2df091"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a6a90140-9e6b-4f93-bf2e-e6ae2f28b9a8",
    x1: 58.38,
    y1: 78.16,
    x2: 131.37,
    y2: 78.16,
    xlinkHref: "#f43567e1-086e-4b37-b6cb-48994d2df091"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.26,
    y: 26.41,
    width: 8.77,
    height: 10.56,
    opacity: 0.2,
    fill: "url(#f43567e1-086e-4b37-b6cb-48994d2df091)",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "31.639999389648438 23.25 31.639999389648438 14.489999771118164 131.5399932861328 23.25 31.639999389648438 23.25",
    opacity: 0.2,
    fill: "url(#a05eb05f-654a-4e10-b5ca-8c551876a400)",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.3699951171875 89.33999633789062 58.380001068115234 66.97000122070312 58.380001068115234 89.33999633789062 131.3699951171875 89.33999633789062",
    opacity: 0.2,
    fill: "url(#a6a90140-9e6b-4f93-bf2e-e6ae2f28b9a8)",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.12,118.4l.47-1.43a226.32,226.32,0,0,0-70.3-11.13c-6.86,0-13.79.32-20.61.94V26.66h12v7.4H57.3a1.48,1.48,0,0,0-1.58,1.58V91.17a1.48,1.48,0,0,0,1.58,1.58h76.14A1.49,1.49,0,0,0,135,91.17V35.64a1.49,1.49,0,0,0-1.58-1.58h-5.75v-7.4h5.92a1.48,1.48,0,0,0,1.58-1.58V13.16a1.48,1.48,0,0,0-1.58-1.58H49.68v-10A1.48,1.48,0,0,0,48.1,0H36.17A1.47,1.47,0,0,0,34.6,1.57v10H30.38a1.48,1.48,0,0,0-1.58,1.58V25.08a1.48,1.48,0,0,0,1.58,1.58H34.6v81.81A313.53,313.53,0,0,0,0,117l.47,1.43.46,1.42.59-.18a309.36,309.36,0,0,1,33.08-8.12v17.64a1.47,1.47,0,0,0,1.57,1.58H48.1a1.48,1.48,0,0,0,1.58-1.58V109.79c6.82-.62,13.75-1,20.61-1a223.18,223.18,0,0,1,68.78,10.8l.58.18Zm-8.26-81.18V89.59h-73V37.22ZM65,34.06v-7.4h59.52v7.4ZM37.75,3.15h8.77v8.43H37.75Zm8.77,124.43H37.75V26.66h8.77ZM32.13,23.5V14.74H132V23.5Z",
    fill: "#22364c",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.48,
    y: 81.08,
    width: 60.27,
    height: 1,
    fill: "#22364c",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.48,
    y: 74.08,
    width: 60.27,
    height: 1,
    fill: "#22364c",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.48,
    y: 67.08,
    width: 60.27,
    height: 1,
    fill: "#22364c",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 129.44 47 L 129.44 57.69 L 129.44 47 Z",
    fill: "#22364c",
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: "7.64096px",
      fontWeight: 700,
      whiteSpace: "pre"
    },
    transform: "matrix(2.536448, 0, 0, 2.355725, -99.987992, -54.32007)",
    x: 70.382,
    y: 52.077
  }, "SELL"), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(34, 54, 76)",
      fontSize: "3.9px"
    },
    x: 96.758,
    y: 51.293,
    transform: "matrix(1, 0, 0, 1, 7.105659, 9.532187)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.3c6235ea39ef8adf9d7dd84d846804fc.svg";
export { ForwardRef as ReactComponent };